export const AD_ACCOUNT_NAME_MAX_LENGTH = 30;
export const ADMIN_USER_NAME_MAX_LENGTH = 20;
export const APP_NAME_MAX_LENGTH = 30;
export const APP_DESCRIPTION_MAX_LENGTH = 30;
export const ADVERTISER_NAME_MAX_LENGTH = 30;

export const COUPON_NAME_MAX_LENGTH = 25;

export const GUIDE_NAME_MAX_LENGTH = 30;

export const MAX_ORDER_NUMBER = 2147483648;

export default {
  install(Vue) {
    Vue.prototype.AD_ACCOUNT_NAME_MAX_LENGTH = AD_ACCOUNT_NAME_MAX_LENGTH;
    Vue.prototype.ADMIN_USER_NAME_MAX_LENGTH = ADMIN_USER_NAME_MAX_LENGTH;
    Vue.prototype.APP_NAME_MAX_LENGTH = APP_NAME_MAX_LENGTH;
    Vue.prototype.APP_DESCRIPTION_MAX_LENGTH = APP_DESCRIPTION_MAX_LENGTH;
    Vue.prototype.ADVERTISER_NAME_MAX_LENGTH = ADVERTISER_NAME_MAX_LENGTH;
    Vue.prototype.COUPON_NAME_MAX_LENGTH = COUPON_NAME_MAX_LENGTH;
    Vue.prototype.GUIDE_NAME_MAX_LENGTH = GUIDE_NAME_MAX_LENGTH;
  }
}
